import { useState, useEffect } from 'react';
import {
    Search
} from 'lucide-react';
import AdminHeader from '@/react-app/components/AdminHeader';

import { useAuthStore } from '@/shared/stores/authStore';
import type { IContact } from '@/shared/types';
// import { useTheme } from '@/react-app/contexts/ThemeContext';
import { api } from '@/shared/api/endpoints';




export default function Notifications() {
    const [searchTerm, setSearchTerm] = useState('');
    const [filterStatus, setFilterStatus] = useState('all');
    const [currentPage, setCurrentPage] = useState(1);
    const { user: authStoreUser, isAuthenticated } = useAuthStore();
    const [loading, setLoading] = useState(true);
    const [totalSMS, setTotalSMS] = useState(0);

    const [stats, setStats] = useState<IContact[] | null>(null);

    const smsPerPage = 20;


    useEffect(() => {
        fetchSMS();
    }, [currentPage, searchTerm, filterStatus]);


    const fetchSMS = async () => {
        try {
            const params = {
                page: currentPage.toString(),
                limit: smsPerPage.toString(),
                search: searchTerm,
                type: filterStatus,

            };

            const response = await api.admin.getSMS(params);
            if (response.success && response.data) {
                setStats(response.data.contacts);
                setTotalSMS(response.data.total);
            }

        } catch (error) {
            console.error('Error fetching transactions:', error);
        } finally {
            setLoading(false);
        }
    };


    // const totalPages = Math.ceil(totalUsers / usersPerPage);
    if (!isAuthenticated || authStoreUser?.role == "user") {
        window.location.href = '/login';
        return null;
    }

    const totalPages = Math.ceil(totalSMS / smsPerPage);

    if (loading) {
        return (
            <div className="min-h-screen dark:bg-gray-900 bg-gray-50">
                <AdminHeader />
                <div className="flex items-center justify-center min-h-[calc(100vh-4rem)]">
                    <div className="text-center">
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-red-600 mx-auto mb-4"></div>
                        <p className="text-gray-600">Loading notifications...</p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen dark:bg-gray-900 bg-gray-50">
            <AdminHeader />

            <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                {/* Header */}
                <div className="flex items-center justify-between mb-8">
                    <div>
                        <h1 className="text-3xl font-bold text-gray-900">Messages Management</h1>
                        <p className="text-gray-600 mt-1">Monitor all platform messages</p>
                    </div>

                </div>


                {/* Filters */}
                <div className="bg-white rounded-2xl p-6 shadow-lg border border-gray-200 mb-8">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
                        {/* Search */}
                        <div className="lg:col-span-2 relative">
                            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" />
                            <input
                                type="text"
                                placeholder="Search transactions..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent"
                            />
                        </div>

                        {/* Type Filter */}
                        <div>
                            <select
                                value={filterStatus}
                                onChange={(e) => setFilterStatus(e.target.value)}
                                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-red-500 focus:border-transparent"
                            >
                                <option value="">All Types</option>
                                <option value="pending">Pending</option>
                                <option value="replied">Replied</option>

                            </select>
                        </div>

                    </div>

                    <div className="mt-4 flex justify-between items-center text-sm text-gray-600">
                        <span>Showing {stats?.length} of {totalSMS} transactions</span>
                        <span>Page {currentPage} of {totalPages}</span>
                    </div>
                </div>

                {/* Transactions Table */}
                <div className="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden">
                    <div className="overflow-x-auto">
                        <table className="w-full">
                            <thead className="bg-gray-50 border-b border-gray-200">
                                <tr>
                                    <th className="px-6 py-4 text-left text-sm font-medium text-gray-900">Name</th>
                                    <th className="px-6 py-4 text-left text-sm font-medium text-gray-900">Subject</th>
                                    <th className="px-6 py-4 text-left text-sm font-medium text-gray-900">Category</th>
                                    <th className="px-6 py-4 text-left text-sm font-medium text-gray-900">Message</th>
                                    <th className="px-6 py-4 text-left text-sm font-medium text-gray-900">Date</th>
                                    {/* <th className="px-6 py-4 text-left text-sm font-medium text-gray-900">Actions</th> */}
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-200">
                                {stats?.map((sms) => (
                                    <tr key={sms._id} className="hover:bg-gray-50 transition-colors">

                                        <td className="px-6 py-4">
                                            <div>
                                                <div className="font-medium text-gray-900">
                                                    {sms.name || 'Unknown User'}
                                                </div>
                                                <div className="text-sm text-gray-500">{sms.email}</div>
                                            </div>
                                        </td>
                                        <td className="px-6 py-4">
                                            <div className="text-sm text-gray-500">{sms.subject}</div>
                                        </td>
                                        <td className="px-6 py-4">
                                            <div className="text-sm text-gray-500">{sms.category}</div>
                                        </td>
                                        <td className="px-6 py-4">
                                            <div className="text-sm text-gray-500">{sms.message}</div>
                                        </td>
                                        <td className="px-6 py-4">
                                            <div className="text-sm">
                                                <div className="text-gray-900">
                                                    {/* {new Date(sms.createdDate).toLocaleDateString()} */}
                                                </div>
                                            </div>
                                        </td>

                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    {/* Pagination */}
                    {totalPages > 1 && (
                        <div className="bg-gray-50 px-6 py-4 border-t border-gray-200">
                            <div className="flex items-center justify-between">
                                <button
                                    onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
                                    disabled={currentPage === 1}
                                    className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                                >
                                    Previous
                                </button>

                                <div className="flex space-x-2">
                                    {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                                        const page = i + Math.max(1, currentPage - 2);
                                        if (page > totalPages) return null;

                                        return (
                                            <button
                                                key={page}
                                                onClick={() => setCurrentPage(page)}
                                                className={`px-3 py-2 text-sm font-medium rounded-lg transition-colors ${currentPage === page
                                                    ? 'bg-red-600 text-white'
                                                    : 'text-gray-700 bg-white border border-gray-300 hover:bg-gray-50'
                                                    }`}
                                            >
                                                {page}
                                            </button>
                                        );
                                    })}
                                </div>

                                <button
                                    onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))}
                                    disabled={currentPage === totalPages}
                                    className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                                >
                                    Next
                                </button>
                            </div>
                        </div>
                    )}
                </div>

                {/* SMS Details Modal */}

            </main>
        </div>
    );
}
